import { styled } from '@mui/material';

export const Code = styled('pre')(({ theme }) => ({
  background: theme.palette.secondary.hover,
  borderRadius: theme.spacing(1),
  fontSize: '0.8rem',
  padding: theme.spacing(1, 2),
}));
